var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.35,59.63c7.61-7.61,7.37-20.11-.74-27.41-7.09-6.38-18.13-6.38-25.23,0-8.1,7.29-8.35,19.79-.74,27.4l12.63,12.63c.4.4,1.05.4,1.45,0l12.62-12.63ZM44.01,77.67l-12.32-12.32c-10.23-10.23-10.78-26.92-.76-37.36,10.42-10.85,27.74-10.85,38.16,0,10.02,10.44,9.47,27.13-.76,37.36l-12.32,12.32c-3.31,3.31-8.68,3.31-11.99,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeCourse);
export default __webpack_public_path__ + "static/media/acae_course.0cbca866.svg";
export { ForwardRef as ReactComponent };